<template>
    <ag-grid-vue
        id="gst-grid"
        style="width: 100%; height: 100%"
        class="gst-base-grid ag-theme-alpine"
        :column-defs="columnDefs"
        dom-layout="autoHeight"
        :default-col-def="defaultColumnDef"
        :pinned-bottom-row-data="totals"
        :row-data="items"
        :pagination="true"
        :pagination-page-size="5"
        :pagination-page-size-selector="[5, 10, 15]"
        :loading-overlay-component="overlayLoadingComponent"
        :no-rows-overlay-component="noRowsOverlayComponent"
        :no-rows-overlay-component-params="noRowsOverlayComponentParams"
        :suppress-cell-focus="true"
        :suppress-row-hover-highlight="true"
        @grid-ready="onGridReady"
        @row-data-updated="onRowDataUpdated" />
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3';
import NoDataTableAgGrid from '../tables/components/NoDataTableAgGrid.vue';
import CustomLoadingOverlay from '../tables/components/CustomLoadingOverlay.vue';
import BaseGridColumnHeader from './headers/BaseGridColumnHeader.vue';

export default {
    name: 'BaseGrid',
    components: {
        AgGridVue,
        /* eslint-disable vue/no-unused-components */
        NoDataTableAgGrid,
        CustomLoadingOverlay,
        BaseGridColumnHeader,
        /* eslint-enable vue/no-unused-components */
    },
    props: {
        columnDefs: {
            type: Array,
            default: () => [],
        },
        items: {
            type: Array,
            default: () => [],
        },
        totals: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        columnNames: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            defaultColumnDef: {
                sortable: true,
                wrapHeaderText: true,
                minWidth: 200,
                width: 200,
                resizable: true,
                headerComponent: BaseGridColumnHeader,
            },
            noRowsOverlayComponentParams: undefined,
        };
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
            this.sizeToFit();
        },
        sizeToFit() {
            this.gridApi.sizeColumnsToFit();
        },
        onRowDataUpdated(params) {
            const { api } = params;
            const rowCount = api.getDisplayedRowCount();

            if (rowCount === 0) {
                this.noRowsOverlayComponentParams = { isFirstLoad: false };
                api.showNoRowsOverlay();
            }
            if (this.loading) {
                api.showLoadingOverlay();
            }
            if (rowCount > 0 && !this.loading) {
                api.hideOverlay();
            }
        },
    },
    mounted() {
        window.addEventListener('resize', this.sizeToFit);
    },
    unmounted() {
        window.removeEventListener('resize', this.sizeToFit);
    },
    created() {
        this.noRowsOverlayComponent = 'NoDataTableAgGrid';
        this.overlayLoadingComponent = 'CustomLoadingOverlay';
    },
};
</script>
